module.exports = __webpack_public_path__ + "img/rule_btn.08d50499.png";